import { Injectable, OnInit } from '@angular/core';
import { HttpserviceService } from './services/httpservice.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  //public urlbase="http://10.38.81.86/";
  
  public urlbase="http://localhost/";
  //public urlbase="http://192.168.68.54/";
  //public urlbase="http://195.140.58.74/"; 
  //public urlbase="http://192.168.1.66/"; 
  public debug=false; 
  public urlwebsockets;
  
  constructor() { 
  
  }

  }
  
